import React, { useState } from "react";
import { useNavigate } from "react-router-dom";


const TestimonialSlider = ({customClass, testimonials, sliderContent}) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className={`testimonial-slider ${customClass}`}>
       <h2>{sliderContent.heading}</h2>
       <p >{sliderContent.subtitle}</p>
      <div className="testimonial-content">
      <img
            src="/images/quote.svg"
            alt="Quote Icon"
          />
        <div className="mobile-slider-controls">
            <button className="slider-btn icon-arrow_back" onClick={handlePrev}>
                &#8592;
            </button>
            <button className="slider-btn icon-arrow_forward" onClick={handleNext}>
                &#8594;
            </button>
        </div>
        <blockquote>        
          {testimonials[currentIndex].quote}
        </blockquote>
        <p>{testimonials[currentIndex].author}</p>
        <span className="testimonial-position">{testimonials[currentIndex].position}
        </span>
      </div>
      <div className="slider-controls">
        <button className="slider-btn icon-arrow_back" onClick={handlePrev}>
            &#8592;
        </button>
        <button className="slider-btn icon-arrow_forward" onClick={handleNext}>
            &#8594;
        </button>
      </div>
      {/* <button className="success-button" onClick={navigate('meet-the-experts')}>Become our next success story <span>&#8594;</span></button> */}
    </div>
  );
};

export default TestimonialSlider;
